import React from 'react'

import ExternalLink from '../ExternalLink'

const NewsletterForm: React.FC<React.HTMLAttributes<HTMLDivElement>> = props => (
  <div {...props}>
    <ExternalLink
      className='p-3 text-lg border border-solid text-gray-100 hover:border-green-200 hover:text-green-200 font-bold rounded plausible-event-name=newsletterLinkClick'
      href='https://planetedurable.substack.com/'
      title='Newsletter'
    >S'inscrire</ExternalLink>
  </div>
)

export default NewsletterForm
